export default "__VITE_ASSET__CxvfH9FL__"